import {
  organization as staticOrganization,
  siteNavigation as staticSiteNavigation,
  website as staticWebsite,
} from '../../static-fields'
import { SEOAllSchemaTypes, SEODynamicSchemaTypes, SEOSchema } from '../../types'
import { getCollectionPage } from '../collection-page/collection-page'

export const getStructuredDataSchema = (props: SEODynamicSchemaTypes): SEOSchema => {
  const {
    faq,
    breadcrumb,
    article,
    blogPosting,
    videoObject,
    itemList,
    webpage,
    howTo,
    collectionPageItemList = [],
    siteNavigation = staticSiteNavigation,
    website = staticWebsite,
    entityOrganization = staticOrganization,
  } = props

  const isCollectionPage = webpage && collectionPageItemList.length > 0

  const finalWebpage = isCollectionPage
    ? getCollectionPage({ webpage, itemList: collectionPageItemList })
    : webpage

  const graphElements = [
    entityOrganization,
    website,
    siteNavigation,
    faq,
    breadcrumb,
    howTo,
    finalWebpage,
    itemList,
    article,
    blogPosting,
    videoObject,
  ].filter((el): el is SEOAllSchemaTypes => !!el)

  return {
    '@context': 'https://schema.org',
    '@graph': graphElements,
  }
}
